import { useRef } from "react";

const Container = ({id = 'container', children = <></>, className = '', ref = null, style = {}}) => {

    const containerRef = useRef(null);
    const currentRef = containerRef || ref;

    return (
        <div id={id} className={`container-fluid px-lg-4 px-3 ${className}`} ref={currentRef} style={style}>
            {children}
        </div>
    );
}

export default Container;